import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from 'vue';
import { ASSETS_STATUSES, ASSET_COLORS } from '@/constants/statuses';

// #interfaces
interface IProps {
  status: string;
}

// #props

export default /*@__PURE__*/_defineComponent({
  __name: 'AppAssetStatus',
  props: {
    status: { default: '' }
  },
  setup(__props: any) {

const props = __props;

// #computed
const getParsedStatus = computed<string>(() => {
  return ASSETS_STATUSES[props.status] || '';
});
const getStatusColor = computed<string>(() => {
  return ASSET_COLORS[props.status] || '#64748B';
});

return (_ctx: any,_cache: any) => {
  return (getParsedStatus.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(['asset-status', `asset-status--${__props.status}`]),
        style: _normalizeStyle({
      backgroundColor: getStatusColor.value
    })
      }, _toDisplayString(getParsedStatus.value), 7))
    : _createCommentVNode("", true)
}
}

})